/**
 * 공지사항 목록 (/adm/notice) — 등록·삭제·보기·푸시알림 팝업
 * ($j.Pages.Admin.NoticeList / body data-page-name="NoticeList")
 */
export default class NoticeList {
    initialize() {
        let $table = null;

        function initHandler(){
            // 등록
            $('#btnWrite').on('click', function(){
                location.href = '/adm/notice/edit?ca=notice';
            });

            // 검색
            $('#btnSearch').on('click', function(){
                $table && $table.ajax.reload();
            });
            $('#search-title').on('keypress', function(e){
                if (e.which === 13) {
                    e.preventDefault();
                    $table && $table.ajax.reload();
                }
            });

            // 목록 row 내 액션 위임
            $('#notice-table tbody').on('click', '.btn-delete', function(){
                const num = $(this).data('num');
                if (!confirm('선택한 글을 삭제 할까요?')) return;
                $.post('/adm/ajax/notice/delete', { num: num }, function(res){
                    if (res && res.result) {
                        $table.ajax.reload(null, false);
                    } else {
                        alert((res && res.message) || '삭제에 실패했습니다.');
                    }
                });
            });
            $('#notice-table tbody').on('click', '.btn-view', function(){
                const num = $(this).data('num'); // g5_notices.num
                window.open(`/adm/notice/${num}`, 'noticeShow',
                    'toolbar=no,status=no,WIDTH=600,HEIGHT=900,directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
            });
            $('#notice-table tbody').on('click', '.btn-push', function(){
                const num = $(this).data('num'); // g5_notices.num
                window.open(`/adm/notice/push?num=${num}`, 'noticePush',
                    'toolbar=no,status=no,WIDTH=500,HEIGHT=700,directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
            });
        }

        function initTable(){
            const columns = [
                { data: 'rownum',        title: 'No',       width: '50px' },
                { data: 'title',         title: '제목',
                    render: function(data, type, row){
                        // 편집 링크의 workrefnum 은 g5_contents.num (= row.num). 레거시 skw_1000 규약과 동일.
                        let html = `<a href="/adm/notice/edit?ca=notice&jobact=editoneline&workrefnum=${row.num}">${data}</a>`;
                        if (row.popup_str) {
                            html += `<br><span class="nt-popup">${row.popup_str}</span>`;
                        }
                        return html;
                    }
                },
                { data: 'is_hidden',     title: '공개여부', width: '80px',
                    render: d => d == 1 ? '비공개' : '공개'
                },
                { data: 'bonsa_str',     title: '대상본사', width: '120px' },
                { data: 'gisa_str',      title: '대상지사', width: '120px' },
                { data: 'tar_type_str',  title: '대상유형', width: '120px' },
                { data: 'datetime_str',  title: '등록일',   width: '120px' },
                { data: null, title: '설정', width: '200px', orderable: false,
                    render: function(data, type, row){
                        return [
                            `<a href="javascript:;" class="btn-delete" data-num="${row.notice_num}">삭제</a>`,
                            `<a href="javascript:;" class="btn-view"   data-num="${row.notice_num}">보기</a>`,
                            `<a href="javascript:;" class="btn-push"   data-num="${row.notice_num}">푸시알림</a>`,
                        ].join(' | ');
                    }
                },
            ];

            $table = new DataTable('#notice-table', {
                autoWidth: false,
                columns: columns,
                headerCallback: thead => $(thead).find('th').css('text-align', 'center'),
                ajax: {
                    url:  '/adm/ajax/notice/list',
                    type: 'post',
                    data: function(d){
                        d.q = $('#search-title').val();
                    },
                },
                language: {
                    emptyTable: '데이터가 없습니다.',
                    info: '', infoEmpty: '', infoFiltered: '',
                    loadingRecords: '로딩 중...',
                    zeroRecords: '일치하는 결과가 없습니다.',
                    paginate: { previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>" },
                },
                processing: true,
                serverSide: true,
                ordering: false,
                pageLength: 15,
                lengthChange: false,
                searching: false,
            });
        }

        initTable();
        initHandler();
    }
}
